<script>
import Spinner from '@/components/general/spinner.vue'
import DisputeDialogBookingDetails from './dispute-dialog-booking-details.vue'
import DisputeDialogClientInfoCard from './dispute-dialog-client-info-card.vue'
import DisputeDialogCandidateInfoCard from './dispute-dialog-candidate-info-card.vue'
import DisputeDialogBookingHistory from './dispute-dialog-booking-history.vue'

export default {
  name: 'DisputesDialogContent',
  components: {
    Spinner,
    DisputeDialogBookingDetails,
    DisputeDialogClientInfoCard,
    DisputeDialogCandidateInfoCard,
    DisputeDialogBookingHistory,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div v-if="!loading">
    <DisputeDialogBookingDetails />

    <v-row class="mb-4">
      <v-col cols="12" md="6"> <DisputeDialogClientInfoCard /> </v-col>
      <v-col cols="12" md="6"> <DisputeDialogCandidateInfoCard /> </v-col>
    </v-row>

    <DisputeDialogBookingHistory />
  </div>
  <Spinner v-else size="60" class="mt-10" />
</template>
